import React from 'react'
import { Logo } from '../../assests/ExportImageIcon'
import './CruiseSearchLoader.css'

const ShipIcon = () => (
    <svg viewBox="0 0 100 58" className='cruiseSearchLoader__shipSvg'>
        <defs>
            <linearGradient id="cruiseSearchLoaderHull" x1="0" y1="0" x2="100" y2="0" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#f0c04a" />
                <stop offset="1" stopColor="#b8860b" />
            </linearGradient>
            <linearGradient id="cruiseSearchLoaderCabin" x1="0" y1="0" x2="0" y2="30" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#3fc98e" />
                <stop offset="1" stopColor="#0f6b4f" />
            </linearGradient>
        </defs>

        <path d="M8 42 H92 L84 54 H16 Z" fill="url(#cruiseSearchLoaderHull)" />
        <rect x="12" y="34" width="76" height="10" rx="2" fill="#eafaf1" />

        <rect x="24" y="20" width="52" height="15" rx="2" fill="url(#cruiseSearchLoaderCabin)" />
        <rect x="34" y="8" width="32" height="13" rx="2" fill="url(#cruiseSearchLoaderCabin)" />

        <rect x="28" y="24" width="6" height="6" rx="1" fill="#f0c04a" />
        <rect x="38" y="24" width="6" height="6" rx="1" fill="#f0c04a" />
        <rect x="48" y="24" width="6" height="6" rx="1" fill="#f0c04a" />
        <rect x="58" y="24" width="6" height="6" rx="1" fill="#f0c04a" />
        <rect x="68" y="24" width="6" height="6" rx="1" fill="#f0c04a" />
        <rect x="39" y="12" width="6" height="5" rx="1" fill="#f0c04a" />
        <rect x="49" y="12" width="6" height="5" rx="1" fill="#f0c04a" />
        <rect x="59" y="12" width="6" height="5" rx="1" fill="#f0c04a" />

        <rect x="66" y="-6" width="9" height="15" rx="2" fill="#0f6b4f" />
        <ellipse cx="70.5" cy="-6" rx="4.5" ry="2" fill="#3fc98e" />

        <line x1="30" y1="8" x2="30" y2="-6" stroke="#b8860b" strokeWidth="1.6" />
        <path d="M30 -6 L40 -3 L30 0 Z" fill="#1a9b6e" />
    </svg>
)

const CruiseSearchLoader = ({ text = 'Booking your cruise', size = 'default' }) => {
    return (
        <div className={`cruiseSearchLoader ${size === 'compact' ? 'cruiseSearchLoader--compact' : ''}`}>
            <div className='cruiseSearchLoader__logoCircle'>
                <img src={Logo} alt='' />
            </div>

            <div className='cruiseSearchLoader__stage'>
                <div className='cruiseSearchLoader__seaWrap'>
                    <div className='cruiseSearchLoader__wave cruiseSearchLoader__wave--w1' />
                    <div className='cruiseSearchLoader__wave cruiseSearchLoader__wave--w2' />
                </div>
                <div className='cruiseSearchLoader__shipAnchor'>
                    <div className='cruiseSearchLoader__shipBob'>
                        <ShipIcon />
                    </div>
                </div>
            </div>

            {text && (
                <p className='cruiseSearchLoader__text'>
                    {text}
                    <span className='cruiseSearchLoader__dots'>
                        <span>.</span><span>.</span><span>.</span>
                    </span>
                </p>
            )}
        </div>
    )
}

export default CruiseSearchLoader
